import { get,put } from "../utils/request";
const requestList={
 productList:'/xxy/product/plan/list', //待处理任务列表接口
 getSupplier:'/xxy/basic/supplier/listAll', //获取供应商接口
 getClient:'/xxy/basic/client/listAll',//获取客户接口
 getInfo:'/xxy/basic/material/getInfo',//获取物料接口
 saveToHandle:'/xxy/product/plan/saveToHandle',//处理页面的接口
};
export function gets(type) {
    return async function (data, options) {
      return await get(requestList[type], data, options);
    };
  }
  export function posts(type) {
    return async function (data, options) {
      return await put(requestList[type], data, options);
    };
  }
  